import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

export default function PayrollInbox({ request, onReview }) {
  const [docs, setDocs] = useState([]);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const load = async () => {
    const inbox = await request("/payrolls/inbox/documents");
    setDocs(inbox.documents || []);
  };
  useEffect(() => { load().catch(e => setError(e.message)); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const run = async action => {
    setBusy(true); setError("");
    try { await action(); await load(); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  return <section aria-label="Entrada por PDF" className="rounded-xl border bg-white p-4">
    <h2 className="font-semibold">Añadir nóminas desde PDF</h2>
    <p className="my-3">Adjunta el PDF de tu gestora. El OCR prepara los datos para que los revises junto al original antes de guardar. Ninguna entrada genera contabilidad ni pagos.</p>
    <form className="flex flex-wrap gap-3" onSubmit={e => { e.preventDefault(); run(async () => {
      const body = new FormData(); body.append("file", file);
      const doc = await request("/payrolls/inbox/documents", { method: "POST", body });
      if (doc.linked_type !== "payroll_inbox") setError("Este PDF ya está registrado. Abre su nómina en el listado.");
    }); }}>
      <label>PDF para OCR<input type="file" required accept="application/pdf,.pdf" onChange={e => setFile(e.target.files?.[0])} /></label>
      <Button disabled={busy || !file} type="submit">Leer PDF</Button>
    </form>
    <h3 className="font-semibold my-3">Pendientes de revisión ({docs.length})</h3>
    {docs.map(doc => <div key={doc.document_id} className="border-t py-3 space-y-2">
      <p>{doc.filename} · {doc.ingest_origin === "email" ? "Correo" : "Subida manual"}</p>
      <p>{doc.ocr_message || "PDF conservado; pendiente de lectura."}</p>
      {doc.suggested_worker_name && <p>Nombre leído (sin asignar): {doc.suggested_worker_name}</p>}
      <Button variant="outline" disabled={busy} onClick={() => onReview(doc)}>Revisar documento</Button>{" "}
      <Button variant="outline" disabled={busy} onClick={() => run(() => request(`/payrolls/inbox/documents/${doc.document_id}/ocr`, { method: "POST" }))}>Reintentar OCR</Button>
    </div>)}
    {busy && <p role="status">Procesando documento…</p>}
    {error && <p role="alert" className="text-red-700">{error}</p>}
  </section>;
}
